import { defineAsyncComponent } from "vue";
import { Button, Dropdown, Menu } from "ant-design-vue";

export const CIcon = defineAsyncComponent(() => import("../components/icon/CIcon"));

export const createButtonDropdown = ({ isLabel = true, text, icon = <></>, items, classStyle, size = "small", onClick = e => e.preventDefault(), disabled }) => {
    if (!items?.length) { return <></>; }

    let label = null;
    let handleOnClick = onClick;
    if (isLabel) {
        label = <span>{text}</span>;
    }

    const menuItems = items
        .filter(d => !d.visible || d.visible?.())
        .map(d => {
        return <Menu.Item onClick={ e => d.onClick?.(e) }>
            { d.icon ? <CIcon file={d.icon}></CIcon> : <></> }
            <span>{ d.text }</span>
        </Menu.Item>
    })

    const menu = (
        <Menu>
            {...menuItems}
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
            <Button class={classStyle} size={size} onClick={handleOnClick} disabled={disabled}>
                {icon}
                {label}
                <CIcon file="caret-down.svg"></CIcon>
            </Button>
        </Dropdown>
    );
};